<script lang="ts">
  import SmallGhostButton from '@/ui/elements/buttons/SmallGhostButton.svelte';

  import ProfileButton from './cmps/ProfileButton.svelte';
  import type { Profile } from './Profile.types';

  interface ProfileProps {
    profile: Profile;
    logOut: () => void;
  }

  let expanded = $state(false);

  const { profile, logOut }: ProfileProps = $props();
  const avatar = $derived.by(() => {
    if (!profile) return ''; // TODO: feature logedout?
    return (
      (profile.firstName?.charAt(0)?.toUpperCase() ?? '') +
      (profile.lastName?.charAt(0)?.toUpperCase() ?? '')
    );
  });
</script>

<div class="relative z-50">
  <ProfileButton {avatar} selected={expanded} onclick={() => (expanded = !expanded)} />
  {#if expanded}
    <div
      class="fc absolute right-0 top-11 min-w-profile gap-3 bg-plain p-4 shadow-card animation-delay-500"
    >
      <div class="fr-ssb gap-4">
        <div class="fc gap-1">
          <p class="text-md font-semibold">{profile.firstName} {profile.lastName}</p>
          <p class="text-sm">{profile.email}</p>
        </div>
        <SmallGhostButton icon="Logout" onclick={logOut} label="Ausloggen" tooltip="Ausloggen" />
      </div>
      <!-- <hr />
      <a href="/TODO" class="text-sm text-c-link hover:underline">Zum Kundenportal</a> -->
    </div>
  {/if}
</div>
